import { styled, Typography } from "@mui/material";

export const DayLabel = styled(Typography)({
    fontFamily: 'Rubik',
    fontSize: '18px',
    textAlign: 'center',
})